import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShopifyRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#95bf47",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m25.4 7.3-.3-.2h-2l-1.8-1.8q-.4-.2-.6 0l-.9.2-.4-1q-.9-1.7-2.5-1.7h-.2v-.1Q16 2 14.8 2q-2 0-3.7 2.7-1.2 2-1.6 4L7 9.3c-.8.3-.8.3-.9 1L4 26.7l17 3 7.4-1.9zM19 5.7l-1.3.5q0-1.2-.5-2.5c1 .2 1.6 1.4 1.8 2m-2.2.7-2.9 1q.5-1.8 1.5-2.9l1-.7q.4 1.4.4 2.6M14.9 3l.8.2-1 .8q-1.3 1.5-1.8 3.7l-2.3.7C11.1 6.2 13 3 15 3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5e8e3e",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.1 7.1h-2l-1.8-1.8-.3-.1v24.4l7.4-1.8-3-20.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17 10.9 16 14s-.9-.4-2-.4c-1.7.1-1.7 1.2-1.7 1.4.1 1.5 3.9 1.8 4.1 5.2.2 2.6-1.4 4.4-3.7 4.5-2.7.2-4.2-1.4-4.2-1.4l.6-2.4s1.5 1.1 2.7 1c.8 0 1-.7 1-1.1 0-1.9-3.1-1.8-3.3-4.8-.2-2.6 1.5-5.3 5.3-5.5z"
		})
	]
});
export default SvgShopifyRegularIcon;
